import { CSS_SELECTOR, useCustomCss } from '../../contexts/CustomCss';
import { FunctionalComponent, h } from 'preact';
import { Tab as StyledTab } from './Tabs.styles';
import { TabProps } from './interface';
import { useTabs } from './Tabs';

export const Tab: FunctionalComponent<TabProps> = ({ ariaLabel, children, forPanel, testid }) => {
  const { select, selected } = useTabs();
  const { rules } = useCustomCss(CSS_SELECTOR.TAB_BUTTON);

  const onClick = () => {
    select(forPanel);
  };

  const active = selected === forPanel;

  return (
    <StyledTab
      active={active}
      aria-label={ariaLabel}
      data-testid={testid}
      type="button"
      role="tab"
      onClick={onClick}
      style={{ ...rules }}
    >
      {children}
    </StyledTab>
  );
};
